// "/" opens the static SELL landing page in public/landing. The app itself starts at /login and /dashboard.
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    window.location.replace('/landing/')
    return new Promise<void>(() => {})
  },
})
